/*
 * @Author: Liuyy
 * @Date: 2020/11/26
 * @Last Modified by: Liuyy
 * @Last Modified time: 2020/11/26
 * @description: 左右切换分页功能 混合
 */
export default {
  data () {
    return {
      maxRestrictIdx: 0,
      isNoNextDisabled: true,
      isNoPrevDisabled: true,
      currentPage: 0,
      translateX: 0
    }
  },
  methods: {
    //会员列表过渡分页展示
    translatePage (type, name, w) {
      this.translateX = type === 'next' ? this.translateX + w : this.translateX - w;
      let vip_list_ul = document.getElementById(name);
      this.currentPage = type === 'next' ? this.currentPage + 1 : this.currentPage - 1;
      this.isNoNextDisabled = this.currentPage === this.maxRestrictIdx - 1 ? true : false;
      this.isNoPrevDisabled = this.currentPage <= 0 ? true : false;
      if (type === 'next') {
        vip_list_ul.style.transform = 'translate(' + [-this.translateX] + 'px)';
      } else {
        vip_list_ul.style.transform = 'translate(' + [-this.translateX] + 'px)';
      }
    },
    //动态设置会员列表（ul）宽度
    dynamicSetWidth (name, childName, type) {
      let items = document.querySelectorAll(childName)
      let width = 0;

      items.forEach(item => {
        width = width + item.offsetWidth
      })
      if (width > 292) {
        if (type !== 'del') {
          this.isNoNextDisabled = false;
        }
        let vip_list_ul = document.getElementById(name);
        vip_list_ul.style.width = width + 'px'
        this.maxRestrictIdx = this.brr.length
      }
    }
  }
}